import { Injectable } from '@angular/core';
import { BlockTypeEnum } from '@app/core/enums';

@Injectable({
  providedIn: 'root'
})
export class FilterRangeService {

  filterStart: any;
  filterEnd: any;
  minValueStart: any;
  maxValueEnd: any;


  constructor() {
    this.filterStart = {
    };

    this.filterEnd = {
    };

    this.minValueStart = {
    };

    this.maxValueEnd = {
    };
  }

}
